import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-h5 font-weight-bold" }, "運営ユーザー設定", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "flat",
        onClick: _ctx.create
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" 新規作成 ", -1))
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_table, { class: "mt-4" }, {
      default: _withCtx(() => [
        _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "text-left" }, "氏名"),
            _createElementVNode("th", { class: "text-left" }, "氏名（カナ）"),
            _createElementVNode("th", { class: "text-left" }, "メールアドレス"),
            _createElementVNode("th", { class: "text-left" }, "管理者"),
            _createElementVNode("th", { class: "text-left" }, "編集"),
            _createElementVNode("th", { class: "text-left" })
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.userId
            }, [
              _createElementVNode("td", null, _toDisplayString(item.lastName) + _toDisplayString(item.firstName), 1),
              _createElementVNode("td", null, _toDisplayString(item.lastNameKana) + _toDisplayString(item.firstNameKana), 1),
              _createElementVNode("td", null, _toDisplayString(item.email), 1),
              _createElementVNode("td", null, [
                (item.isAdmin)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      label: "",
                      size: "small",
                      color: "secondary"
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode(" 管理者 ", -1)
                      ]))]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, "-"))
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_v_btn, {
                  to: `/admin-user/edit/${item.userId}`,
                  color: "primary",
                  variant: "outlined",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" 編集 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("td", null, [
                (item.isDisabled)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      size: "small",
                      color: "error"
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode(" mdi-block-helper ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}